<template>
  <v-select
    label="Client Title"
    :outlined="outlined"
    :dense="dense"
    :items="items"
    item-text="title"
    item-value="title"
    v-model="selectedClientTitle"
    @change="onChange"
    :clearable="clearable"
  ></v-select>
</template>

<script>
import { removeGQLTypename } from "../../../helpers";
import { ALL_CLIENT_TITLES_SEARCH_QUERY } from "../../../constants/graphql";
export default {
  name: "client-title-list-select",

  props: {
    dense: {
      type: Boolean,
      default: () => false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    clearable: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      selectedClientTitle: this.value ? this.value : null,
    };
  },
  computed: {
    items() {
      return this.clientTitles && this.clientTitles.edges
        ? this.clientTitles.edges
            .map(removeGQLTypename)
            .filter((t) => !t.notInUse)
        : [];
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.selectedClientTitle = newVal;
      }
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.selectedClientTitle);
    },
  },

  apollo: {
    clientTitles: {
      query: ALL_CLIENT_TITLES_SEARCH_QUERY,
      /*
      variables() {
        return {
          filter: {
            not_in_use_eq: false,
          },
        };
      },
      */
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ClientTitleListSelect.vue